import { post } from '../Services/http';
const rootRoute = '/api/gtm';
import { catchError } from './Error.action';

export const addToCartEvent = (articleNumber, quantity) => (dispatch) => {
    return post(`${rootRoute}/add-to-cart`, { articleNumber, quantity })
        .then(response => response.json())
        .then(data => {
            addToDataLayer(data);
        })
        .catch(ex => dispatch(catchError(ex, error => console.error(error))))
        ;
}

export const beginCheckoutEvent = () => (dispatch) => {
    return post(`${rootRoute}/begin-checkout`)
        .then(response => response.json())
        .then(data => {
            addToDataLayer(data);
        })
        .catch(ex => dispatch(catchError(ex, error => console.error(error))))
        ;
}

export const removeFromCartEvent = (rowId, quantity) => (dispatch) => {
    return post(`${rootRoute}/remove-from-cart`, { rowId, quantity })
        .then(response => response.json())
        .then(data => {
            addToDataLayer(data);
        })
        .catch(ex => dispatch(catchError(ex, error => console.error(error))))
        ;
}

const addToDataLayer = (data) => {
    dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
    console.log("DataLayer push", window.dataLayer);

};
